import React, { FC } from 'react'

import { Alert } from '@app/types/alert'
import { AppIcon } from '@app/components/AppIcon'
import { useTimeController } from '@app/hooks/contexts/timeController/TimeControllerContext'

import theme from '../../../../../../../theme'
import AppAlertBase from '../../../../../../../components/AppAlertBase'
import AlertEventTime from '../../../../../../../components/AlertEventTime'

interface SidebarMskPainAlertProps {
	readonly alert: Alert
}

const SidebarMskPainAlert: FC<SidebarMskPainAlertProps> = ({
	alert,
}: SidebarMskPainAlertProps) => {
	const {
		formatters: { df },
	} = useTimeController()
	const eventTime = df(alert.op?.addedTimestamp)
	const title = alert.data?.alert_description || ''

	return (
		<>
			<AppAlertBase
				iconSlot={
					<AppIcon
						type={'increasePainSmile'}
						width={32}
						height={27}
					/>
				}
				iconBoxSx={{
					bgcolor: theme.palette.secondary.light,
					height: 'auto',
				}}
				title={title}
			/>

			<AlertEventTime eventTime={eventTime} />
		</>
	)
}

export default SidebarMskPainAlert
